import styled from 'styled-components'

export const CarouselDotStyled = styled.button<{ $isActive: boolean }>`
  width: ${(props) => props.theme.typography.pxToRem(8)};
  height: ${(props) => props.theme.typography.pxToRem(8)};
  padding: 0;
  border: 0;
  border-radius: 50%;
  background-color: ${(props) =>
    props.$isActive
      ? props.theme.colors.primary
      : props.theme.colors.content.border};
  cursor: pointer;

  &:hover {
    background-color: ${(props) =>
      props.$isActive
        ? props.theme.colors.primary
        : props.theme.colors.textTertiary};
  }
`
